import React, { useState } from "react";
import {
  ShoppingCart,
  BarChart,
  LogOut,
  Store,
  Users,
  Tags,
  Home,
  User2,
  Menu,
  X,
  LayoutDashboard,
  ChevronRight,
} from "lucide-react";

export default function Sidebar({
  active,
  onLogout,
  role,
  onNavigate,
  collapsed = false,
  onToggleCollapse,
}) {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  // Get user data from localStorage
  const rawUser = localStorage.getItem("user");
  const user = rawUser ? JSON.parse(rawUser) : null;
  const userName = user?.name || user?.username || "User";

  const adminMenus = [
    {
      key: "overview",
      label: "Overview",
      path: "/admin/dashboard/overview",
      icon: LayoutDashboard,
    },
    {
      key: "dashboardAdmin",
      label: "User List",
      path: "/admin/dashboard",
      icon: Users,
    },
    {
      key: "users",
      label: "Manage Users",
      path: "/admin/users",
      icon: User2,
    },
    {
      key: "home",
      label: "Home",
      path: "/",
      icon: Home,
    },
  ];

  const userMenus = [
    {
      key: "overview",
      label: "Overview",
      path: "/dashboard/overview",
      icon: LayoutDashboard,
    },
    {
      key: "transaksi",
      label: "Transactions",
      path: "/transaksi",
      icon: ShoppingCart,
    },
    {
      key: "outlet",
      label: "Outlets",
      path: "/outlet",
      icon: Store,
    },
    {
      key: "categories",
      label: "Categories",
      path: "/categories",
      icon: Tags,
    },
    {
      key: "laporan",
      label: "Reports",
      path: "/laporan",
      icon: BarChart,
    },
    { key: "home", label: "Home", path: "/", icon: Home },
  ];

  const menus = role === "admin" ? adminMenus : userMenus;

  const handleNavigate = (path) => {
    if (path === "/") {
      window.location.href = "/";
      return;
    }

    if (onNavigate) {
      onNavigate(path);
    }
    setIsMobileOpen(false);
  };

  const handleLogout = () => {
    onLogout();
    setIsMobileOpen(false);
  };

  const SidebarContent = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        background: "#ffffff",
        transition: "width 0.2s ease",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: collapsed ? "16px 12px" : "20px",
          borderBottom: "1px solid #e2e8f0",
          display: "flex",
          alignItems: "center",
          gap: collapsed ? "0" : "12px",
          justifyContent: collapsed ? "center" : "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: collapsed ? "0" : "12px",
            marginBottom: 0,
          }}
        >
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "18px",
              flexShrink: 0,
            }}
          >
            💰
          </div>
          {!collapsed && (
            <div>
              <h4
                style={{
                  margin: 0,
                  fontWeight: "700",
                  color: "#0f172a",
                  fontSize: "18px",
                  letterSpacing: "-0.02em",
                }}
              >
                Kasku
              </h4>
              <p
                style={{
                  margin: "4px 0 2px 0",
                  fontSize: "13px",
                  color: "#0f172a",
                  fontWeight: "600",
                }}
              >
                {userName}
              </p>
              <p
                style={{
                  margin: 0,
                  fontSize: "11px",
                  color: "#94a3b8",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  fontWeight: "600",
                }}
              >
                {role === "admin" ? "Admin Panel" : "User Panel"}
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Navigation */}
      <div
        style={{
          flex: 1,
          padding: collapsed ? "14px 8px" : "16px 12px",
          overflowY: "auto",
          scrollbarWidth: "thin",
          scrollbarColor: "#cbd5e1 transparent",
        }}
      >
        <nav>
          {menus.map((m) => {
            const isActive = active === m.key;
            const Icon = m.icon;

            return (
              <button
                key={m.key}
                type="button"
                onClick={() => handleNavigate(m.path)}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: collapsed ? "0" : "12px",
                  justifyContent: collapsed ? "center" : "flex-start",
                  padding: collapsed ? "11px" : "10px 12px",
                  marginBottom: "4px",
                  border: "none",
                  borderRadius: "8px",
                  background: isActive ? "#eff6ff" : "transparent",
                  color: isActive ? "#3b82f6" : "#64748b",
                  fontSize: "14px",
                  fontWeight: isActive ? "600" : "500",
                  cursor: "pointer",
                  transition: "all 0.15s ease",
                  position: "relative",
                  textAlign: "left",
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background = "#f8fafc";
                    e.currentTarget.style.color = "#0f172a";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color = "#64748b";
                  }
                }}
              >
                <Icon size={18} strokeWidth={2} />
                {!collapsed && <span style={{ flex: 1 }}>{m.label}</span>}
                {isActive && !collapsed && <ChevronRight size={16} />}
              </button>
            );
          })}

          {/* Logout moved into nav so it's not hidden by mobile browser bars */}
          <div
            style={{
              marginTop: collapsed ? "10px" : "14px",
              paddingTop: "10px",
              borderTop: "1px solid #e2e8f0",
            }}
          >
            <button
              type="button"
              onClick={handleLogout}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: collapsed ? "0" : "12px",
                justifyContent: collapsed ? "center" : "flex-start",
                padding: collapsed ? "11px" : "10px 12px",
                border: "1px solid #fee2e2",
                borderRadius: "8px",
                background: "#fef2f2",
                color: "#dc2626",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#fee2e2";
                e.currentTarget.style.borderColor = "#fecaca";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#fef2f2";
                e.currentTarget.style.borderColor = "#fee2e2";
              }}
            >
              <LogOut size={18} strokeWidth={2} />
              {!collapsed && <span>Logout</span>}
            </button>
          </div>
        </nav>
      </div>
    </div>
  );

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        type="button"
        onClick={() => setIsMobileOpen(!isMobileOpen)}
        style={{
          position: "fixed",
          top: "12px",
          right: "12px",
          zIndex: 1200,
          width: "40px",
          height: "40px",
          background: "rgba(255, 255, 255, 0.96)",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow:
            "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          color: "#0f172a",
          backdropFilter: "blur(8px)",
        }}
        className="d-lg-none"
      >
        {isMobileOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      {/* Desktop Sidebar */}
      <aside
        className="d-none d-lg-flex"
        style={{
          width: collapsed ? "80px" : "260px",
          height: "100vh",
          background: "#ffffff",
          borderRight: "1px solid #e2e8f0",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 1000,
          flexShrink: 0,
          transition: "width 0.2s ease",
          overflow: "hidden",
          paddingRight: collapsed ? "6px" : "12px",
        }}
      >
        <SidebarContent />

        {onToggleCollapse && (
          <button
            type="button"
            onClick={onToggleCollapse}
            aria-label={collapsed ? "Tampilkan sidebar" : "Sembunyikan sidebar"}
            style={{
              position: "absolute",
              top: "14px",
              right: collapsed ? "-14px" : "-14px",
              width: "36px",
              height: "36px",
              borderRadius: "999px",
              border: "1px solid #e2e8f0",
              background: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
              cursor: "pointer",
            }}
          >
            <ChevronRight
              size={16}
              style={{
                transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          </button>
        )}
      </aside>

      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div
          onClick={() => setIsMobileOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.4)",
            zIndex: 1050,
            backdropFilter: "blur(2px)",
          }}
          className="d-lg-none"
        />
      )}

      {/* Mobile Sidebar */}
      {isMobileOpen && (
        <div
          className="d-lg-none"
          style={{
            width: "260px",
            height: "100vh",
            background: "#ffffff",
            borderRight: "1px solid #e2e8f0",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1100,
            animation: "slideIn 0.2s ease-out",
            boxShadow: "4px 0 24px rgba(0, 0, 0, 0.12)",
          }}
        >
          <SidebarContent />
        </div>
      )}

      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: translateX(0);
          }
        }
      `}</style>
    </>
  );
}
